// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__biHe1","footer":"ModalCreateQualiphyProcedure_footer__32Ivz","additionData":"ModalCreateQualiphyProcedure_additionData__8_eup"};